import { useI18n } from "../i18n";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";

export const usePaypalReturn = (refresh) => {
  const { t } = useI18n();
  const [params, setParams] = useSearchParams();
  useEffect(() => {
    const st = params.get("pagamento");
    if (!st) return undefined;
    setParams({}, { replace: true });
    if (st === "annullato") { toast(t("ppCancel")); return undefined; }
    toast.success(t("ppOk"));
    const ids = [3000, 8000, 15000].map((ms) => setTimeout(refresh, ms));
    return () => ids.forEach(clearTimeout);
  }, [params, setParams, refresh, t]);
};
